import React,{useRef, useState, useEffect} from "react";
import { Toast} from "react-bootstrap";


class Filter extends React.Component {

	
	constructor(props) {
		
		super(props);
		
		this.hc = 'bg-secondary-subtle';
		
		this.state = {
			bg: "primary",
			
		};
		
		this.elements = this.props.options;
		
		this.id = crypto.randomUUID();
		
		this.selectedElements = this.props.defaultValue ? this.props.defaultValue : [];
		
	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	
	handleEnter(){
		
		this.updateStatus({
			bg:this.props.setup.bg ? this.props.setup.bg : this.state.bg
		});
		
		
	}
	handleExit(){
	
	}
	handleClose(){
		
		this.props.onClose({open:false});
	}
	handleChange(){
		
		this.props.onChange(this.selectedElements);
	}
	deSelect(item){
		
		var i = typeof item === 'object' ? item : {value:item, label:item};
		
		this.remove(i);
		this.handleChange();
		return false;
	}
	select(item){
		
		if(!this.props.isMulti)
			this.reset();
		
		var i = typeof item === 'object' ? item : {value:item, label:item};
		
		this.add(i);
		this.handleChange();
		return false;
	}
	isSelected(item){
		
		if(Array.isArray(this.selectedElements))
			return this.selectedElements.findIndex((i)=>{
				return item.value === i.value;
			});
		return -1;
	}
	add(item){
		var idx = this.isSelected(item);
		
		if(idx === -1){
			this.selectedElements.push(item);
		}
	}
	remove(item){
		var idx = this.isSelected(item);
		if(idx>-1){
			this.selectedElements.splice(idx, 1);
		}
	}
	reset(){
		this.selectedElements = [];
		var self = this;
		this.elements.forEach((elem, idx)=>{
			document.getElementById("select"+self.id+idx).classList.remove(this.hc);
		});
		
	}
	setValue(items){
		this.selectedElements = items;
		this.forceUpdate();
	}
	
	handleClick(e){
		e.stopPropagation();
		var elem = e.target;
		var item = this.elements[elem.dataset.value];
		
		if(elem.classList.contains(this.hc)){
			elem.classList.remove(this.hc)
			this.deSelect(item);
		}
		else if(!elem.classList.contains(this.hc)){
			elem.classList.add(this.hc)
			this.select(item);
		}
		
		//this.props.onClose({open:false});
	}

	render() {
		return (
			<>
			{this.elements.map((e, idx)=>{
				
				var selected = ( this.isSelected(e) > -1 );
				return (
					<span key={idx} role="button" id={"select"+this.id+idx} onClick={(e)=>{this.handleClick(e)}} data-value={idx} className={"filter-text d-inline-block p-1 px-2 my-1 me-4 rounded  border border-secondary-subtle "+ (selected ? this.hc : '')}>{e.label}</span>
				);
			})}
			</>
		);
	}
}

export default Filter;